/* tslint:disable */
/* eslint-disable */
/**
 * Module Format Contest 
 * Api Format Contest
 *
 * OpenAPI spec version: v1.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContentCMS } from './content-cms';
/**
 * 
 * @export
 * @interface GameConfiguration
 */
export interface GameConfiguration {
    /**
     * 
     * @type {string}
     * @memberof GameConfiguration
     */
    gamePlayerName?: string;
    /**
     * 
     * @type {string}
     * @memberof GameConfiguration
     */
    gestureType?: GameConfigurationGestureTypeEnum;
    /**
     * 
     * @type {ContentCMS}
     * @memberof GameConfiguration
     */
    title?: ContentCMS;
    /**
     * 
     * @type {ContentCMS}
     * @memberof GameConfiguration
     */
    before?: ContentCMS;
    /**
     * 
     * @type {ContentCMS}
     * @memberof GameConfiguration
     */
    during?: ContentCMS;
    /**
     * 
     * @type {ContentCMS}
     * @memberof GameConfiguration
     */
    after?: ContentCMS;
    /**
     * 
     * @type {ContentCMS}
     * @memberof GameConfiguration
     */
    win?: ContentCMS;
    /**
     * 
     * @type {ContentCMS}
     * @memberof GameConfiguration
     */
    loose?: ContentCMS;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GameConfiguration
     */
    gameConfiguration?: { [key: string]: string; };
}

/**
    * @export
    * @enum {string}
    */
export enum GameConfigurationGestureTypeEnum {
    CLICK = 'CLICK',
    UPDOWN = 'UP_DOWN',
    LEFTRIGHT = 'LEFT_RIGHT',
    RANDOM = 'RANDOM'
}

